$(document).ready(function() {
  $('.thumbnail').each(function() {
    var str = $(this).attr('alt');
    if (str.match("^vimeo.com")) {
      $(this).wrap("<a data-fancybox class='fancybox' href='https://" + str + "'></a>");
    };
   
  });
  
  $(".fancybox").fancybox({
    opacity: 1,
    vimeo : {

	}
  });
    
});